import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import infoIco from 'assets/images/i-circle.svg';
import successIco from 'assets/images/check.png';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import OtpModal from 'shared/common/modal/otp_modal';
import ChangePassword from './change-password';
import DocumentUpload from './document-upload';
import UserHttp from '../services/profile.service';
import PanCardUpload from './pan-card-upload';
import { customerRouteMap } from 'routes';
import DashboardHttp from '../services/profile.service';
import getProfile from 'Redux/profile/profile.reducers';

interface PropsType {
  user: any;
  customer: any;
  incomeSource: any;
  incomeGroup: any;
}

// const incomeGroupObj = {

// }

const UserInfo: React.FC<PropsType> = ({ user, customer, incomeSource, incomeGroup }) => {
  // console.log(customer, "@customer");


  const [panNumber, setPanNumber] = useState<any>('');
  const [aadhaarNumber, setAadhaarNumber] = useState<any>('');

  const [isPanVerify, setPanVerify] = useState(true);
  const [isPanVerifing, setPanVerifing] = useState(false);
  const [isPanVerifySuccess, setPanVerifySuccess] = useState(false);
  const [isPanVerifyFeild, setPanVerifyFeild] = useState(false);

  const [isAadhaarVerify, setAadhaarVerify] = useState(true);
  const [isAadhaarVerifing, setAadhaarVerifing] = useState(false);
  const [isAadhaarVerifySuccess, setAadhaarVerifySuccess] = useState(false);
  const [isAadhaarVerifyFeild, setAadhaarVerifyFeild] = useState(false);

  const [modalShow, setModalShow] = React.useState(false);
  const [otp, setOtp] = useState<any>();
  const [resend, setResend] = useState(false);

  const [isShow, setIsShow] = useState(false);
  const [isShowUpload, setIsShowUpload] = useState(false);

  const [isDocShow, setDocShow] = useState(false);

  const [docs, setDocs] = useState<any>([]);

  const [txtSuscces, setTxtSuscces] = useState('');
  const [txtError, setTxtError] = useState('');

  const [EmailDisable, setEmailDisable] = useState(true);

  const [formData, setFormData] = useState({
    dob: "",
    gender: "",
    incomeSource: "",
    incomeGroup: "",
  });

  const [editableFields, setEditableFields] = useState({
    dob: true,
    gender: true,
    incomeSource: true,
    incomeGroup: true,
  });
  const [errors, setErrors] = useState<any>({});
  const [isFormComplete, setIsFormComplete] = useState(false);


  // Simulate API call
  useEffect(() => {
    const fetchData = async () => {
      const apiResponse = {
        dob: customer?.kyc?.aadhaar?.data?.dob
          ? customer?.kyc?.aadhaar?.data?.dob
          : customer?.dob
            ? customer.dob
            : "",

        gender: customer?.kyc?.aadhaar?.data?.gender
          ? customer?.kyc?.aadhaar?.data?.gender
          : customer?.gender
            ? customer?.gender
            : "",
        incomeSource: customer?.incomeSource ? customer?.incomeSource : "",
        incomeGroup: customer?.incomeGroup ? customer?.incomeGroup : "",
      };
      setFormData(apiResponse);

      // Set editable fields based on empty data
      setEditableFields({
        dob: !apiResponse.dob,
        gender: !apiResponse.gender,
        incomeSource: !apiResponse.incomeSource,
        incomeGroup: !apiResponse.incomeGroup,
      });
      // validateForm(apiResponse);
    };

    fetchData();
  }, [user, customer]);




  useEffect((): any => {
    if (user?.kyc?.aadhaar?.data?.maskedAadhaarNumber) {
      if (user?.kyc?.aadhaar?.isVerified) verifyAadhaarSuccess();
      setAadhaarNumber(user.kyc.aadhaar.data.maskedAadhaarNumber);
    }
  }, [user]);

  useEffect((): any => {
    if (customer?.kyc?.pan?.value) {
      setPanNumber(customer.kyc.pan.value);
      verifySuccess();
    }
  }, [customer]);





  const toVerify = () => {
    setPanVerify(true);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifyInprograss = () => {
    setPanVerify(false);
    setPanVerifing(true);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifySuccess = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(true);
    setPanVerifyFeild(false);
  };

  const verifyFeild = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(true);
  };

  const toAadhaarVerify = () => {
    setAadhaarVerify(true);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarInprograss = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(true);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarSuccess = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(true);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarFeild = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(true);
  };

  const panVerify = async () => {
    if (isPanVerifySuccess) return;
    verifyInprograss();
    try {
      const res: any = await CustomerOnboardingHttp.verifyPanNumber({
        pan: panNumber,
      });
      if (res && res.status === 200) {
        //setPanNumber(res.data.data.kycId);
        verifySuccess();
      } else {
        verifyFeild();
        //toast.error(res.data.errors[0].title);
      }
      // setLoading(false);
    } catch (err: any) {
      verifyFeild();
      console.log(err);
      // toast.error(err.data.errors[0].title);
    }
  };

  const aadhaarVerify = async () => {
    if (isAadhaarVerifySuccess) return;

    verifyAadhaarInprograss();

    if (!aadhaarNumber) {
      verifyAadhaarFeild();
      return;
    }
    try {
      //setAadhaarNumber(values.aadhaar_number);
      const res: any = await CustomerOnboardingHttp.sendAadhaarOtp(
        {
          name: user.displayName,
          aadhaarNo: aadhaarNumber,
          consent: true,
          user_id: user?.userId

        },
        user?.userId
      );

      if (res && res.status === 200) {
        setModalShow(true);
        setTxtSuscces('OTP has been sent.');
        setTxtError('');
      } else {
        setTxtError(res.data.errors[0].title);
        toast.error(res.data.errors[0].title);
      }
    } catch (err: any) {
      // setUsernameError(err.message);
      console.log(err);
      toast.error(err.data.errors[0].title);
      verifyAadhaarFeild();
      //setError(err);
    }
  };

  const onAadhaarSuccess = async (otp) => {
    setOtp(otp);

    try {
      const data = {
        otp: otp,
        aadhaarNo: aadhaarNumber,
      };
      const res: any = await CustomerOnboardingHttp.verifyAadhaarOtp(
        data,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setModalShow(false);
        verifyAadhaarSuccess();
        //createIndCustomer();
      } else {
        toAadhaarVerify();
      }
    } catch (e: any) {
      toast.error(e.data.errors[0].title);
      verifyAadhaarFeild();
      console.log(e);
    }
  };

  const resendOtp = () => {
    aadhaarVerify();
    setResend(false);
  };

  const changePassword = () => {
    onHandleSideModal(true);
  };

  const onHandleSideModal = (value) => {
    setIsShow(value);
  };

  const onHandleUploadSideModal = (value) => {
    setIsShowUpload(value);
  };

  const onHandleDocSideModal = (value) => {
    setDocShow(value);
  };

  const getDocs = async () => {
    setDocShow(true);
  };

  const onEmailEdit = () => {
    setEmailDisable(!EmailDisable);
  };

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    validateForm({ ...formData, [field]: value });
  };

  const validateForm = (data) => {
    const newErrors = {};
    Object.keys(data).forEach((key) => {
      if (!data[key]) newErrors[key] = "This field is required.";
    });
    setErrors(newErrors);
    setIsFormComplete(Object.keys(newErrors).length === 0);
  };

  const handleSaveDetails = async (e) => {
    e.preventDefault();

    if (!isFormComplete) {
      toast.warning("Please fill all required fields.");
      return;
    }
    try {
      const res = await DashboardHttp.updateProfileDetails(customer?.customerId, formData,);

      if (res.status === 202) {
        const data = await DashboardHttp.getProfile(customer.customerId, user.userId);
        setIsFormComplete(false);

        toast.success("Details saved successfully!");
        if (data.status == 200 && data.data) {
          setEditableFields({
            dob: false,
            gender: false,
            incomeGroup: false,
            incomeSource: false
          })
        }


      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to save details. Please try again.");
    }
  };
  return (
    <>
      <Toast />
      <ChangePassword handleModal={onHandleSideModal} isShow={isShow} />

      <DocumentUpload
        handleModal={onHandleDocSideModal}
        isShow={isDocShow}
        customerId={customer.customerId}
      />
      <PanCardUpload
        handleModal={onHandleUploadSideModal}
        isShow={isShowUpload}
        customerId={customer.customerId}
      />
      <Card>
        <Card.Body className='p-5 pb-0'>
          <div>
            <Card.Title>Personal Information</Card.Title>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='name'>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='text'
                    value={user?.displayName || ''}
                  />
                </Form.Group>
              </Col>
              {/* <Col md={6}>
                <Form.Group className='mb-3' controlId='email'>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='email'
                    value={user?.email?.value || ''}
                  />
                </Form.Group>
              </Col> */}

              <Col md={6}>
                <Form.Group className='mb-3' controlId='password'>
                  <Form.Label>Email</Form.Label>
                  <div className='input-group mb-3'>
                    <Form.Control
                      disabled={EmailDisable}
                      type='text'
                      value={user?.email?.value || ''}
                    />
                    <div className='input-group-text'>
                      {/* <button
                        className='btn'
                        onClick={onEmailEdit}
                        type='button'
                        id='button-addon2'
                      >
                        {EmailDisable?'Edit':"Save"}
                      </button> */}
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='mobile'>
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='text'
                    value={user?.mobile?.value || ''}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='password'>
                  <Form.Label>Password</Form.Label>
                  <div className='input-group mb-3'>
                    <Form.Control
                      disabled={true}
                      type='password'
                      value='......'
                    />
                    <div className='input-group-text'>
                      <button
                        className='btn'
                        onClick={changePassword}
                        type='button'
                        id='button-addon2'
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="dob">
                  <Form.Label>DOB</Form.Label>
                  <Form.Control
                    disabled={!editableFields.dob}
                    type="date"
                    max={new Date().toISOString().split("T")[0]}
                    value={formData.dob}
                    onChange={(e) => handleChange("dob", e.target.value)}
                  />
                  {errors.dob && <small className="text-danger">{errors.dob}</small>}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3" controlId="gender">
                  <Form.Label>Gender</Form.Label>
                  <Form.Select
                    disabled={!editableFields.gender}
                    value={formData.gender ? formData.gender : ""}
                    onChange={(e) => handleChange("gender", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="O">Other</option>
                  </Form.Select>
                  {errors.gender && <small className="text-danger">{errors.gender}</small>}
                </Form.Group>
              </Col>

            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="income-source">
                  <Form.Label>Income Source</Form.Label>
                  <Form.Select
                    disabled={!editableFields.incomeSource}
                    value={formData.incomeSource}
                    onChange={(e) => handleChange("incomeSource", e.target.value)}
                  >
                    <option value="">Select</option>
                    {incomeSource?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.incomeSource && (
                    <small className="text-danger">{errors.incomeSource}</small>
                  )}
                </Form.Group>
              </Col>


              <Col md={6}>
                <Form.Group className="mb-3" controlId="income-group">
                  <Form.Label>Annual Income</Form.Label>
                  <Form.Select
                    disabled={!editableFields.incomeGroup}
                    value={formData.incomeGroup}
                    onChange={(e) => handleChange("incomeGroup", e.target.value)}
                  >
                    <option value="">Select</option>
                    {incomeGroup?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.incomeGroup && (
                    <small className="text-danger">{errors.incomeGroup}</small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="row">
              <div className="mt-2 d-flex justify-content-end py-4">
                <Button
                  variant="primary"
                  className="mw"
                  type="button"
                  disabled={!isFormComplete}
                  onClick={handleSaveDetails}
                >
                  Save
                </Button>

              </div>
            </div>

          </div>
        </Card.Body>
        <div className='mb-3'></div>
      </Card>
      <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title={'Enter the OTP sent your Aadhar registered Mobile Number'}
        onSuccess={(otp) => onAadhaarSuccess(otp)}
        resend={resendOtp}
        txtSuscces={txtSuscces}
        txtError={txtError}
      />
    </>
  );
};

export default UserInfo;
